<template>
    <div class="row justify-content-center" v-if="suitability != null">
    <div class="col-12 col-md-12 col-lg-10 col-xl-10 form-container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-10 col-xl-10">
                <div class="tit text-center">
                    <img src="/static/assets/images/ico-complete.svg" style="margin-bottom:40px; width:60px;" alt="icone arquivo">
                    <h1>
                        <span>Seu perfil de investimento é:</span> {{this.suitability.Tipo}}
                    </h1>
                    <div>
                        <p class="nome">
                            &nbsp;
                        </p>
                        <p v-html="texto">
                        </p>
                        <p class="obs">
                            Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.
                        </p>

                        <div >
                            <router-link to="/informacoes-adicionais/suitability" class="btn btn-sm btn-primary" title="Preencher novamente">Preencher novamente</router-link>
                            <router-link to="/investimentos/meus-investimentos" class="btn btn-sm btn-primary" title="Oportunidades abertas">Oportunidades abertas <img src="/static/assets/images/angle-right.svg"></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<style lang="scss" scoped>

	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";

  .card {
  	margin-bottom: 30px;
  }

  .item {
  	margin-bottom: 20px;

  	p {
  		padding: 0 0 5px 0;
  		margin: 0px;
  		color: #000;
  		font-weight: bold;

  		strong {
			color: $c3;
  		}
  	}

  	table {
  		thead {
  			th {
  				border-top:none;
  			}
  		}
  		tr {
  			border-bottom: none;
  		}

  		&.forms {
  			margin:0 0 20px;
  			td {
  				padding:2px 0;
  			}
  		}
  	}
  }

  .list-check {

  	li {
  		display: inline-block;
  		padding-right: 30px;
  		text-transform: uppercase;
  		font-weight: bold;

  		i {
  			color: green;
  		}
  	}
  }

  .form-check {
  	display: flex;



  	label {
  		font-size: 15px!important;
  		font-weight: normal!important;
  	}
  }

</style>

<script>
    /* eslint-disable */
    import ApiClient from '../utils/api-client'
    import steps from '@/components/InformationSuitability'
    import * as mutationTypes from '@/store/mutation-types.js'
    import ArrayHelper from '@/utils/array-helper'
    import HubConsultaClient from '../utils/hub-consulta-client.js'

    let components = Object.assign({}, steps)

    export default {
        data() {
            return {
                suitability: null,
                texto :""
            }
        },
        computed: {
        },
        methods: {
            Preencher()
            {
                this.$router.push({path: `/informacoes-adicionais/suitability`})
            },
            Oportunidades()
            {

                this.$router.push({path: '/investimentos/meus-investimentos'})
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/informacoes-adicionais/suitabilityVerify',
                    title: 'Suitability Verify',
                })
            },
        },
        async created() {

            this.$Loading.update(0)
            this.$store.commit(mutationTypes.STOP_LOADING)

            // ATUALIZA TAG NO ACTIVE CAMPAIN ...
            HubConsultaClient.AtualizarActive(this.$store.state.currentUser.email, "usuario-cadastro-investidor-incompleto")
            

            ApiClient.get(`suitabilityVerify`)
                .then(response => {

                   if(response.data != null)
                   {
                       this.suitability = response.data;

                       if(this.suitability.Tipo == "Conservador")
                       {
                           this.texto = `Verificamos que você busca rendimentos modestos, o investidor conservador possui a segurança como referência para as suas aplicações, assumindo os menores riscos possíveis. Em razão da sua baixa tolerância ao risco, mantém em sua carteira percentual reduzido de produtos de renda variável, dando preferência aos produtos de renda fixa.
                                        <br>Dessa forma, esteja ciente dos riscos e benefícios de investir através do empréstimo coletivo (peer-to-peer lending).
                                        <br>Esperamos que este seja o começo de uma parceria de muito sucesso entre você e a IOUU.`
                       }
                        if(this.suitability.Tipo == "Moderado")
                       {
                           this.texto = `Você procura equilibrar rentabilidade com risco. É um investidor que prefere a segurança da renda fixa, mas também aplica parte de seus recursos em renda variável, visando retornos acima da média do mercado. Por isso, ficamos felizes em informar que você já pode começar seus investimentos conosco. Esperamos que este seja o começo de uma parceria de muito sucesso entre você e a IOUU.`
                       }

                        if(this.suitability.Tipo == "Arrojado")
                       {
                           this.texto = `Você busca sempre alta rentabilidade, mesmo que corra riscos de perder parte do patrimônio. Assume posições mais concentradas e especulativas como forma de alcançar um maior retorno.
                                        <br>Você tem ciência dos riscos e benefícios de investir atráves do empréstimo coletivo (peer-to-peer lending).
                                        <br>Esperamos que este seja o começo de uma parceria de muito sucesso entre você e a IOUU.`
                       }

                        if(this.suitability.Tipo == "Super agressivo" || this.suitability.Tipo == "Agressivo")
                       {
                           this.texto = `Você possui total conhecimento e amplo domínio dos produtos de investimento. Você busca retornos muito expressivos no curto prazo, suportando quaisquer riscos.
                                        <br>Você tem ciência dos riscos e benefícios de investir atráves do empréstimo coletivo (peer-to-peer lending).
                                        <br>Esperamos que este seja o começo de uma parceria de muito sucesso entre você e a IOUU.`
                       }
                   }
                   else
                   {
                     this.Preencher();

                   }
                   this.$store.commit(mutationTypes.STOP_LOADING);
                })
                .catch(() => this.$store.commit(mutationTypes.STOP_LOADING))

            //tagueamento GA
            await this.taggingGA();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/InformationSuitabilityVerify.vue